import { useEffect, useState, useCallback } from 'react';

export default function useLazyState(lazyValue, settle) {
  const [state, setState] = useState({ value: lazyValue });
  const settleState = useCallback(value => setState({
    value,
    settled: true,
  }), [setState]);

  // "lazyValue" can be a delayed value, e.g. originating in a promise;
  // presumably, its value will flip from undefined to something at most once,
  // and the associated form fields will not be rendered before the initialization is complete;
  // in any case, once the value is settled, updating lazyValue cannot impact the state anymore
  useEffect(() => {
    if (!state.settled) {
      setState({
        value: lazyValue,
        settled: !!settle,
      });
    }
  }, [lazyValue, settle, state.settled]);

  return [state.value, settleState, state.settled];
}

